<template>
  <div class="bookinfo">
    <div class="bookinfo-wrap">
      <div class="bookinfo-img-wrap">
        <img class="bookinfo-img" :src="getBookinfo.image">
      </div>
      <div class="bookinfo-text-wrap">
        <button v-on:click="readBook()" class="read-btn">Read it</button>
        <div class="bookinfo-text-row">
          <div class="bookinfo-text-row-left">
            Title
          </div>
          <div class="bookinfo-text-row-right">
            {{getBookinfo.name}}
          </div>
        </div>
        <div class="bookinfo-text-row">
          <div class="bookinfo-text-row-left">
            Level
          </div>
          <div class="bookinfo-text-row-right">
            {{getBookinfo.level}}
          </div>
        </div>
        <div class="bookinfo-text-row">
          <div class="bookinfo-text-row-left">
            Author
          </div>
          <div class="bookinfo-text-row-right">
            {{getBookinfo.author}}
          </div>
        </div>
        <div class="bookinfo-text-row-summary">
          <div class="bookinfo-text-row-left">
            Summary
          </div>
          <div class="bookinfo-text-row-right">
            {{getBookinfo.summary}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  computed: {
    getBookinfo() {
      return this.$store.getters.getSelectedBook
    }
  },
  methods: {
    readBook(){
      // console.log('Selected a book: ')
      // console.log(this.getBookinfo.isbn)
      this.$router.push(`/book/${this.getBookinfo.isbn}`);
    }
  },
  mounted() {
    if(Object.entries(this.getBookinfo).length === 0) {
      this.$router.push(`/booklist`);
    }
  }
}
</script>

<style scoped>
  .bookinfo {
    margin-top: 70px;
  }
  .bookinfo-text-wrap div{
    margin-bottom: 5px;
  }
  .bookinfo-text-row-right {
    text-align: left;
  }
  .bookinfo-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;
  }
  .bookinfo-img {
    max-width: 250px;
    border-radius: 2px;
    /* box-shadow: -4px 5px 14px -4px rgba(0,0,0,0.5); */
    box-shadow: -5px 5px 5px -2px rgba(0, 0, 0, 0.2);
    margin-bottom: 20px;
  }

  .bookinfo-text-wrap {
    width: 250px;
    display: flex;
    /* justify-content: center; */
    flex-direction: column;
    /* align-items: center; */
  }

  .bookinfo-text-row, .bookinfo-text-row-summary {
    display: flex;
  }
  .bookinfo-text-row-summary {
    text-align: left;
    flex-direction: column;
  }

  .bookinfo-text-row-left {
    font-weight: bold;
    margin-right: 5px;
  }

  .read-btn {
    color: white;
    background-color: #4caf50;
    margin-bottom: 20px;
    height: 35px;
    border: none;
    cursor: pointer;
    box-shadow: -3px 3px 5px -2px rgba(0, 0, 0, 0.2);
    font-weight: 500;
    border-radius: 3px;
  }
  
  .read-btn:hover {
    background-color: rgba(76,175,80, 0.9);
  }

  .read-btn:focus {
    outline:0;
  }

  @media screen and (min-width: 768px) {
    .bookinfo-wrap {
      margin-top: 30px;
      flex-direction: row;
      justify-content: center;
      align-items: start;
    }
    .bookinfo-img { 
      margin-right: 30px;
      margin-bottom: 0;
    }
    .read-btn {
      margin-top: 20px;
      margin-bottom: 0;
      order: 2;
    }
    .bookinfo {
      margin-top: 100px;
    }
  }

</style>